export const keyMap = {
  SPACE: { key: [' ', 'Spacebar'], keyCode: 32 },
  ENTER: { key: 'Enter', keyCode: 13 },
  TAB: { key: 'Tab', keyCode: 9 },
  ESCAPE: { key: 'Escape', keyCode: 27 },
} as const;
